import { BR_POINT_MOBILE, ETALON_MQ, STEP } from "../constants";
import { createTheme } from "@mui/material/styles";

const CSS_NUMBER_REGEX = /(-?\d*\.?\d+)(px)?/gi;

export function scaleCssValue(value: any, scaleFn: (n: number) => number) {
  if (typeof value === "number") {
    return scaleFn(value);
  }

  if (typeof value !== "string") return value;

  // do not scale percentages, vw, vh, rem, em, fr
  if (/(%|vw|vh|rem|em|fr)/i.test(value)) {
    return value;
  }

  // Replace numeric px values
  return value.replace(CSS_NUMBER_REGEX, (match, num, pxUnit) => {
    if (!pxUnit) return match; // do not scale unitless numbers like fontWeight
    const scaled = scaleFn(Number(num));
    return `${scaled}px`;
  });
}

export function createResponsiveScaler(
  windowWidth: number,
  etalonMQ: number,
  step = 200
) {
  const snappedWidth =
    step > 0 ? Math.round(windowWidth / step) * step : windowWidth;

  return (value: number) => (value * snappedWidth) / etalonMQ;
}

export function scaleTypographyVariant(
  variant: Record<string, any>,
  scaleFn: (v: number) => number,
  mdBreakpoint: number
) {
  const out: any = {};
  const mobile = variant.mobile || null;

  for (const key in variant) {
    if (key === "mobile") continue;

    const value = variant[key];

    if (value && typeof value === "object" && !Array.isArray(value)) {
      out[key] = scaleTypographyVariant(value, scaleFn, mdBreakpoint);
    } else {
      out[key] = scaleCssValue(value, scaleFn);
    }
  }

  if (mobile) {
    out[`@media (max-width:${mdBreakpoint}px)`] = {
      ...mobile,
    };
  }

  return out;
}

export function scaleAllTypographyVariants(
  typography: any,
  windowWidth: number,
  etalonMQ: number,
  step: number,
  mdBreakpoint: number
) {
  const scaleFn = createResponsiveScaler(windowWidth, etalonMQ, step);

  const out: any = {};

  for (const key in typography) {
    const variant = typography[key];

    if (typeof variant === "object") {
      out[key] = scaleTypographyVariant(variant, scaleFn, mdBreakpoint);
    } else {
      out[key] = variant;
    }
  }

  return out;
}

export function createResponsiveTheme(baseTheme: any) {
  if (typeof window === "undefined") return baseTheme;

  const windowWidth = window.innerWidth;
  const mq = baseTheme.breakpoints.values[BR_POINT_MOBILE];

  const scaledTypography = scaleAllTypographyVariants(
    baseTheme.typography,
    windowWidth,
    ETALON_MQ,
    STEP,
    mq
  );

  return createTheme(baseTheme, {
    typography: scaledTypography,
  });
}


